/* Busy indicator widget */
import * as React from "react";
import { observer } from "mobx-react";
import * as s from "./main.css";
import { CircularProgress } from "material-ui/Progress";

@observer
export default class Busy extends React.Component< {show:boolean, size?:string, msg?:string, center?:boolean}, {} > {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    let size: number = 32;
    let thick: number = 3;
    switch (this.props.size) {
      case "med":
        size = 64;
        thick = 5;
        break;
      case "lg":
        size = 128;
        thick = 7;
        break;
    }
    const clsName: string = this.props.center ? s.center : null;
    if (this.props.show) {
      return <div className={clsName}>
        <CircularProgress size={size} color="secondary" thickness={thick} />
        <div>{this.props.msg}</div>
        </div>
    } else {
      return null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/widgets/busy/index.tsx